"use strict";

var _taggedTemplateLiteral = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js").default;
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AtomSVGTooltip = function AtomSVGTooltip(_ref) {
  var x = _ref.x,
    y = _ref.y,
    quadrant = _ref.quadrant,
    innerHTML = _ref.innerHTML;
  var top, left, rotation;
  switch (quadrant) {
    case 1:
      {
        rotation = 180;
        top = true;
        left = false;
        break;
      }
    case 2:
      {
        rotation = 90;
        top = true;
        left = true;
        break;
      }
    case 3:
      {
        rotation = 0;
        top = false;
        left = true;
        break;
      }
    case 4:
      {
        rotation = 270;
        top = false;
        left = false;
        break;
      }
  }
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(StyledTriangePath, {
    d: 'M0,0 30,-15 15,-30 Z',
    style: {
      transform: "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg)")
    }
  }), react_1.default.createElement("foreignObject", {
    style: {
      width: '100%',
      height: '100%'
    }
  }, react_1.default.createElement(StyledContainer, {
    style: {
      transform: "translate(".concat(x, "px, ").concat(y, "px)")
    }
  }, react_1.default.createElement(StyledTooltip, {
    top: top,
    left: left
  }, innerHTML))));
};
exports.default = react_1.default.memo(AtomSVGTooltip);
var StyledTriangePath = styled_components_1.default.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: var(--highlight);\n"])));
var StyledTooltip = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transform-box: 'fill-box';\n  transform-origin: 'center';\n  transform: ", ";\n  border-radius: 2px;\n  padding: 0.5em;\n  background-color: var(--highlight);\n  box-shadow: 2px 2px 10px -3px var(--atom-brand-2);\n"])), function (_ref2) {
  var top = _ref2.top,
    left = _ref2.left;
  return "translate(".concat(left ? '10%' : '-110%', ", ").concat(top ? '10%' : '-110%', ")");
});
var StyledContainer = styled_components_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: fit-content;\n"])));
var StyledRow = styled_components_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: var(--text-primary);\n  font-size: 0.75em;\n"])));